import React, {
  ReactElement,
} from 'react';
import {SchemaWithClient} from '../../types/SchemaWithClient';
import {Entity} from '../../types/entities/Entity';
import {CommentWall} from "./CommentWall";
import {Box} from '@mui/material';
import {SocketProvider} from "./contexts/MessageSocketContext";

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};

export const AccommodationReservationComment = ({
                                            schema,
                                            values,
                                            fullWidth,
                                          }: {
  schema: any;
  values: any;
  fullWidth: boolean;
}): ReactElement => {

  return <>
    <Box
      sx={{
        background: '#fff',
        p: '10px',
        width: '100%',
        borderRadius: '8px',
        '& .MuiFormControl-root.MuiTextField-root': {}
      }}>
      <SocketProvider schema={schema} tableType={'accommodation_reservation'} values={values}>

        <CommentWall schema={schema} values={values} tableType={'accommodation_reservation'} setVisibleColumns={() => {

        }}/>

      </SocketProvider>
    </Box>

  </>;

}